import { render, staticRenderFns } from "./RightToBuyDiscount.vue?vue&type=template&id=47c19c92"
import script from "./RightToBuyDiscount.vue?vue&type=script&lang=js"
export * from "./RightToBuyDiscount.vue?vue&type=script&lang=js"
import style0 from "./RightToBuyDiscount.vue?vue&type=style&index=0&id=47c19c92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports